import * as React from "react";
import { IHeaderButton } from "src/ScrollyInterface";
import { getTextStyle } from "src/shared/getTextStyle";
import "./HeaderButton.scss";

const headerButton = (props: IHeaderButton) => {
  const { header, links, styles, showSideDrawer } = props;
  const headerText = header ? header.text : "";

  const style = showSideDrawer
    ? {
      transform: "translate(0px, 0px) translateZ(0px)",
      transitionDuration: "500ms",
      transitionTimingFunction: "cubic-bezier(0.1, 0.57, 0.1, 1)"
    }
    : {
      transform: "translateX(20%)",
      transitionDuration: "500ms",
      transitionTimingFunction: "cubic-bezier(0.1, 0.57, 0.1, 1)"
    };

  return (
    <div className="HeaderButton" style={style}>
      <a href={links.home} target="_blank" className="HeaderButton-link">
        <span
          className="HeaderButton-text"
          style={{ ...getTextStyle(header), ...styles }}
        >
          {headerText}
        </span>
      </a>
    </div>
  );
};

export default headerButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/HeaderButton.tsx